function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { getPersons } from '../api';
import { RANGE_ABOUT, RANGE_AFTER, RANGE_BEFORE, RANGE_BETWEEN, RANGE_EXACT } from './DateRangeGroup';
export { ClearButton } from './ClearButton';
export { DateRangeGroup } from './DateRangeGroup';
export { GivenNameInput } from './GivenNameInput';
export { ResultsPerPageSelect } from './ResultsPerPageSelect';
export { SearchButton } from './SearchButton';
export { SearchPlaceInput } from './SearchPlaceInput';
export { SurnameInput } from './SurnameInput';
export { SortBySelect } from './SortBySelect';
export { SortOrderSelect } from './SortOrderSelect';
export var extractPeriodFromData = function extractPeriodFromData(data) {
  var yearAfter = undefined,
      yearBefore = undefined;

  if (data.rangeType === RANGE_BETWEEN) {
    yearAfter = data.yearAfter;
    yearBefore = data.yearBefore;
  } else if (data.rangeType === RANGE_AFTER) {
    yearAfter = data.year;
  } else if (data.rangeType === RANGE_BEFORE) {
    yearBefore = data.year;
  } else if (data.rangeType === RANGE_EXACT) {
    yearAfter = data.year;
    yearBefore = data.year;
  } else if (data.rangeType === RANGE_ABOUT) {
    var pm = parseInt(data.yearPlusMinus || 5);

    if (data.year) {
      var year = parseInt(data.year);
      yearAfter = (year - pm).toString();
      yearBefore = (year + pm).toString();
    }
  } else {
    throw new Error(data.rangeType);
  }

  return [yearAfter, yearBefore];
};
export var getPersonsFromFormData = function getPersonsFromFormData(data) {
  var _extractPeriodFromDat = extractPeriodFromData(data),
      _extractPeriodFromDat2 = _slicedToArray(_extractPeriodFromDat, 2),
      yearAfter = _extractPeriodFromDat2[0],
      yearBefore = _extractPeriodFromDat2[1];

  return getPersons((data.currentPage - 1) * data.resultsPerPage, data.resultsPerPage, data.surname, data.givenName || undefined, data.place.length ? data.place[0].id : undefined, data.sortBy, yearAfter, yearBefore, data.sortOrder);
};